import { blobClient, client } from '@api/client';
import { URL } from '@api/urls';

import { IAssetOwner, TAsset } from '@interfaces/assets/asset';
import { TExportAssetsDTO } from '@interfaces/assets/dto/assetsDTO';
import { IItemsResponse } from '@interfaces/common/response';
import { IManageAcquiredAssetsRange } from '@interfaces/rent/assetRent';
import { IManageAcquiredAssetsDTO } from '@interfaces/rent/dto/assetRentDTO';

import { DEFAULT_END_DATE, DEFAULT_START_DATE } from '@constants/common';

const {
	acquiredAssets,
	manageAcquiredAssetsAssetOwners,
	exportAcquiredAssets,
} = URL;

export const getAcquiredAssets = (
	data: IManageAcquiredAssetsDTO,
	range: IManageAcquiredAssetsRange,
): Promise<IItemsResponse<TAsset>> => {
	return client.get(acquiredAssets, {
		params: {
			...data,
			'range.from': range?.fromDate || DEFAULT_START_DATE,
			'range.to': range?.toDate || DEFAULT_END_DATE,
		},
	});
};

export const getAcquiredAssetOwners = (): Promise<IAssetOwner[]> => client.get(manageAcquiredAssetsAssetOwners);

export const exportManageAcquiredAssets = (dto: TExportAssetsDTO): Promise<void> => {
	return blobClient.post(exportAcquiredAssets, dto);
};
